<template>
  <div class="wt-credit-page">
    <layout-general>
      <layout-header slot="header"></layout-header>
      <div class="wt2-sg" slot="left">
        <div class="-left-bar-credit">
          <div class="wt2-text-xl -title">Credit</div>
          <div class="-subtitle">Enter your text in the preview area.</div>
        </div>
      </div>
      <main-stage slot="main">
        <credit-stage :active="true" :primary="true"></credit-stage>
        <super-stage :active="true" :primary="false"></super-stage>
      </main-stage>
      <credit-apply-cancel slot="footer"></credit-apply-cancel>
    </layout-general>
  </div>
</template>

<script>
import LayoutGeneral from '../layouts/LayoutGeneral.vue';
import LayoutHeader from '../layouts/LayoutHeader.vue';
import CreditStage from '../functionality/Credit/CreditStage.vue';
import CreditApplyCancel from '../functionality/Credit/CreditApplyCancel.vue';
import SuperStage from '../functionality/Super/SuperStage.vue';
import MainStage from '../functionality/Stage/MainStage.vue';

export default {
  components: {
    LayoutGeneral,
    LayoutHeader,
    CreditStage,
    CreditApplyCancel,
    SuperStage,
    MainStage,
  },
};
</script>
